import { createElement } from 'react'
import { FlagCell } from 'routes/shared/components'
import { createInWinImage } from 'shared/components/table/cellRenderers'
import { Delete } from '../shared/local/components/deleteButton'
import { Update } from '../shared/local/components/updateButton'

// Create common beneficiary control
export const createColumns = () => [
  {
    Header: 'Logo',
    accessor: 'logo',
    Cell: createInWinImage,
    minWidth: 100,
    width: 100,
  },
  {
    Header: 'Team Name',
    accessor: 'teamName',
    minWidth: 200,
    style: {
      whiteSpace: 'normal',
      wordWrap: 'break-word',
    },
  },
  {
    Header: 'Sport',
    accessor: 'sport',
  },
  {
    Header: 'Jurisdiction',
    accessor: 'jurisdiction.logo',
    Cell: FlagCell,
  },
  {
    Header: 'Team Website',
    accessor: 'teamWebsite',
  },
  {
    Header: 'Update',
    id: 'controls',
    minWidth: 110,
    width: 110,
    accessor: (value) => value,
    Cell: (props) => createElement(Update, { ...props }),
  },
  {
    Header: 'Delete',
    id: 'controls',
    minWidth: 130,
    width: 130,
    accessor: (value) => value,
    Cell: (props) => createElement(Delete, { ...props }),
  },
]
// id: types.maybeNull(types.number),
// teamName: types.maybeNull(types.string),
// logo: types.maybeNull(types.string),
// sport: types.maybeNull(types.string),
// league: types.maybeNull(types.string),
// athletesIds: types.array(types.number),
// teamWebsite: types.maybeNull(types.string),
// jurisdiction: types.optional(JurisdictionModel, {}),
